import { Bell } from 'lucide-react';

import { persistLocaleCookie } from '@/app/context/locale/localeCookie';
import { ToggleLocale, Translation, useDynamicLocale } from '@/hoslog-intl';
import { formatDate } from '@/lib/dateFormatter';
import { formatDateJp } from '@/lib/dateFormatterJp';

export const Navbar = () => {
  const dayEN = new Date().toLocaleDateString('en-US', { weekday: 'long' });
  const dayJP = new Date().toLocaleDateString('ja-JP', { weekday: 'long' });
  const today = formatDate(new Date(), 'DD/MM/YYYY');
  const todayJP = formatDateJp(new Date());
  const { locale } = useDynamicLocale();

  const handleLocaleChange = () => {
    persistLocaleCookie(locale);
  };
  return (
    <div className="flex basis-full bg-card h-[70px] font-bold justify-between items-center px-4 py-2 sm:px-18 sm:py-3.75 ">
      <div>
        <p>
          <Translation id="navbar.title.welcome" />
          👋
        </p>
        <p className=" text-xs text-foreground-subtle font-medium">
          {locale === 'en' ? `${dayEN}, ${today}` : `${todayJP} (${dayJP})`}
        </p>
      </div>
      <div className="flex gap-4 items-center">
        <Bell className="hidden sm:inline" size={32} />
        <ToggleLocale onChange={handleLocaleChange} />
      </div>
    </div>
  );
};
